// Libs
import axios from 'axios'
import { SubmissionError } from 'redux-form'
import { useLocation, useHistory } from 'react-router-dom'
import _ from 'lodash'

// Actions
import { changeLocalLoading, changeErr, changeSuccess } from '../App/actions'
import { changeUserField, fetchUserCompanies, randomImage } from '../Auth/actions'
import { fetchOperations } from '../Swap/actions'
import { resetDashboardData } from '../Dashboard/actions'
import { signOut } from '../Deauth/actions'
import { resetFilterPanelParams } from '../FilterPanel/actions'
import { reset, change } from 'redux-form'

// Contants
import { getLocalStorage } from '../../constants/others'

// Axios
import { serverAPI } from '../../index'

export function profile(data, swap = false, history) {
  const formData = new FormData();

  if (!_.isEmpty(data.file)) {
    data.file = data.file[0]
  }

  for (const key in data) {
    if (data[key]) {
      formData.append(key, data[key])
    }
  }

  return function (dispatch) {
    dispatch(changeLocalLoading(true))
    return serverAPI.put('/user/profile', formData)
      .then(response => {
        const { file } = data
        // const location = useLocation()
        const pathname = window.location.pathname;

        // Change image URL
        if (file) {
          dispatch(randomImage())
        }
        data.capture = response.data.capture
        data.updatedPassword = response.data.updatedPassword
        Object.keys(data).forEach(key => {
          // Set data in reduxForm
          dispatch(change('profile', key, data[key]))
          // Set data in localStorage/store
          dispatch(changeUserField({ key, value: data[key] }))
        });

        dispatch(changeLocalLoading(false))

        if (pathname === '/tour/0' || pathname === '/tour/0-b') {
          // Redirect to '/tour/1-1'
          history.push('/tour/1-1')
        }

        if (swap) {
          dispatch(fetchUserCompanies())
          dispatch(resetDashboardData())
          dispatch(resetFilterPanelParams())
          dispatch(reset('filter'))
          dispatch(fetchOperations(data.userId))
          history.push('/dashboard')
        } else {
          dispatch(changeSuccess('O seu perfil foi alterado.'))
        }
      })
      .catch((e) => {
        console.log(e)
        dispatch(changeLocalLoading(false))
        switch (e.response.status) {
          case 409:
            throw new SubmissionError({
              password: "A nova senha não pode ser igual às últimas 5 senhas utilizadas. Por favor, escolha uma senha diferente."
            });
          case 422:
            throw new SubmissionError({
              password: 'A nova senha não atende aos requisitos de segurança. Por favor, escolha uma senha mais forte.'
            })
          case 800:
            throw new SubmissionError({
              email: 'Este email já está cadastrado.'
            })
          case 802:
            throw new SubmissionError({
              email: 'Esta senha não é a atual.'
            })
          case 803:
            throw new SubmissionError({
              password: 'Sua nova senha não pode ser igual a antiga.'
            })
          default:
            dispatch(changeErr(`Ocorreu um erro no envio do formulário. Entre em contato com um de nossos operadores via chat`))
        }
      })
  }
}
